// extracted by mini-css-extract-plugin
export default {"login-form":"SigninForm_login-form__a54T8","login-form-button":"SigninForm_login-form-button__CPMoX"};